import { render, staticRenderFns } from "./vizetipekledialog.vue?vue&type=template&id=0d56fbe4"
import script from "./vizetipekledialog.vue?vue&type=script&lang=js"
export * from "./vizetipekledialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports